import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, Phone } from "lucide-react";

export const CareTeamMember = ({ member, onCall }) => (
  <div className="flex items-center gap-3 p-2">
    <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center">
      <span className="text-teal-700 font-semibold">
        {member.name?.charAt(0) || "?"}
      </span>
    </div>
    <div className="flex-1">
      <p className="font-medium text-slate-800">{member.name}</p>
      <p className="text-xs text-slate-500">{member.role}</p>
    </div>
    <Button size="sm" variant="ghost" onClick={() => onCall?.(member)}>
      <Phone className="w-4 h-4" />
    </Button>
  </div>
);

export const CareTeamCard = ({ team = [], onCallMember }) => (
  <Card className="bg-white shadow-sm" data-testid="care-team-card">
    <CardHeader className="pb-2">
      <CardTitle className="text-lg flex items-center gap-2">
        <Users className="w-5 h-5 text-blue-500" />
        Your Care Team
      </CardTitle>
    </CardHeader>
    <CardContent>
      {team.length === 0 ? (
        <p className="text-slate-500 text-center py-4">Care team info loading...</p>
      ) : (
        <div className="space-y-3">
          {team.map((member, index) => (
            <CareTeamMember 
              key={member.id || index} 
              member={member} 
              onCall={onCallMember}
            />
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);

export default CareTeamCard;
